module.exports = "<p>\n  leadcrm-dashboaard works!\n</p>\n"